import { render } from "./App.vue?vue&type=template&id=06c8264b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=06c8264b&lang=css"
script.render = render

export default script